module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_photowedding_03-4f19c52b0f4c101633e7bbbd7c693b24.webp";